import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { AppI18nContext, ConfigurationI18nContext, TranslationNamespace, UiI18nContext, initializeI18n, useFetchBackendTranslations, useFetchUiTranslations, } from "@plansoft-configuration-renderer/localization";
import { ConsoleLogger, LogLevels, unique, } from "@plansoft-configuration-renderer/utils";
import { createMissingKeyHandlerOptions } from "./MissingTranslations/createMissingKeyHandlerOptions";
const logger = new ConsoleLogger("LocalizationProvider", LogLevels.warn);
const UI_CONTEXTS = [TranslationNamespace.ConfigurationRenderer];
export function LocalizationProvider(props) {
    const { children } = props, restOptions = __rest(props, ["children"]);
    return (_jsx(UiLocalizationProvider, Object.assign({}, restOptions, { children: _jsx(ConfigurationLocalizationProvider, Object.assign({}, restOptions, { children: children })) })));
}
function UiLocalizationProvider(props) {
    const { children } = props, options = __rest(props, ["children"]);
    const { configuratorBasePath, datamanagerBasePath, configurationLocale, uiLocale = configurationLocale, uiContexts = UI_CONTEXTS, } = options;
    const localeCodes = useMemo(() => unique([uiLocale, configurationLocale]), [uiLocale, configurationLocale]);
    const { data, isFetching } = useFetchUiTranslations({
        datamanagerBasePath,
        configuratorBasePath,
        contexts: uiContexts,
        localeCodes,
    });
    const [appI18n, uiI18n] = useMemo(() => {
        logger.log("UiLocalizationProvider", {
            configurationLocale,
            uiLocale,
            data,
        });
        const missingKeyOptions = createMissingKeyHandlerOptions();
        const commonOptions = Object.assign({ defaultNS: false, ns: [...uiContexts], keySeparator: false, nsSeparator: ":", resources: data !== null && data !== void 0 ? data : {} }, missingKeyOptions);
        const appI18n = initializeI18n(Object.assign(Object.assign({}, commonOptions), { lng: uiLocale }), []);
        const uiI18n = initializeI18n(Object.assign(Object.assign({}, commonOptions), { lng: configurationLocale, fallbackLng: uiLocale }), []);
        return [appI18n, uiI18n];
    }, [configurationLocale, uiContexts, uiLocale, data]);
    return (_jsx(AppI18nContext.Provider, { value: appI18n, children: _jsx(UiI18nContext.Provider, { value: uiI18n, children: isFetching ? null : children }) }));
}
function ConfigurationLocalizationProvider(props) {
    const { children, configurationLocale, configuratorBasePath } = props;
    const { data, isFetching } = useFetchBackendTranslations({
        basePath: configuratorBasePath,
        localeId: configurationLocale,
    });
    const configurationI18n = useMemo(() => {
        logger.log("ConfigurationLocalizationProvider", { configurationLocale });
        const resources = data
            ? {
                [configurationLocale]: {
                    [TranslationNamespace.Configuration]: data,
                },
            }
            : {};
        return initializeI18n({
            lng: configurationLocale,
            defaultNS: TranslationNamespace.Configuration,
            ns: [TranslationNamespace.Configuration],
            keySeparator: ".", // nested objects
            resources,
        }, []);
    }, [configurationLocale, data]);
    return (_jsx(ConfigurationI18nContext.Provider, { value: configurationI18n, children: isFetching ? null : children }));
}
//# sourceMappingURL=LocalizationProvider.js.map